















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { List, Checkbox, CheckboxGroup, Button } from 'vant';
import SearchInput from '@/components/SearchInput.vue';
import VoteButton from '@/components/VoteButton.vue';
import { getVoteList } from '@/api/api';
Vue.use(List)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Button);
@Component({
  components: {
    SearchInput,
    VoteButton,
  },
})
export default class VoteList extends Vue {
  @Prop() listType!: number;
  @Prop() option!: any;
  listActiveType: number = 3;
  loading = false;
  finished = false;
  loadingStatus = false;
  doStartSearch = false;
  ifDoSearch = false;
  page = 1;
  searchPage = 1;
  getListData: any[] = [];
  displayImages: any[] = [];
  result = [];
  SearchData = '';
  clearValue: any = '';
  @Watch('listType')
  onListTypeChanged(newVal: number) {
    this.page = 1;
    this.getListData = [];
    this.finished = false;
    this.loading = false;
    this.SearchData = '';
    this.clearValue = Date.now();
    this.listActiveType = newVal;
    this.onLoad();
  }
  // @Watch('doStartSearch')
  // onDoStartSearch(newVal: number, val: number) {
  //   console.log('用户点击了搜索');
  //   this.searchPage = 1;
  // }
  get source() {
    return this.$route.params.source;
  }
  created() {
    console.log('List的source参数：', this.source);
    // const canvas = document.createElement('canvas');
    // const context = canvas.getContext('2d');
    // const videoFile = e.target.files[0];
    // const domVideo: any = document.querySelector('#video');
    // const scale = 0.5;
    // canvas.width = domVideo.videoWidth * scale;
    // canvas.height = domVideo.videoHeight * scale;
    // if (!context) {
    //   return;
    // }
    // setTimeout(() => {
    //   context.drawImage(domVideo, 0, 0, canvas.width, canvas.height);
    //   this.displayImages.push(canvas.toDataURL('image/png'));
    // }, 1000);
  }
  onLoad() {
    console.log('onLoad加载开始了。搜索内容为：', this.SearchData);
    if (this.loadingStatus === false) {
      this.loadingStatus = true;
      if (this.SearchData) {
        this.startSearch(2);
      } else {
        setTimeout(() => {
          getVoteList({
            voteName: this.option.voteName,
            page: this.page,
            type: this.listActiveType,
          }).then((res) => this.endVoteListData(res));
        }, 150);
      }
    }
  }
  endVoteListData(res: any) {
    if (!res.data) {
      this.finished = true;
    } else {
      this.getListData = [...this.getListData, ...res.data];
      this.page = this.page + 1;
    }
    this.loading = false;
    this.loadingStatus = false;
  }
  enterDetail(item: any) {
    if (this.$route.params.source) {
      this.$router.push({
        path: '../Detail',
        query: { id: item.id, type: item.work_type, source: this.source },
      });
    } else {
      this.$router.push({
        path: './Detail',
        query: { id: item.id, type: item.work_type, source: this.source },
      });
    }
  }
  fetchSearch(e: any) {
    this.SearchData = e;
  }
  // 开始搜索
  startSearch(e: any) {
    console.log('进入搜索', e);
    this.loadingStatus = true;
    if (e === 1) {
      this.page = 1;
      this.getListData = [];
      this.loading = false;
      this.finished = false;
    }
    getVoteList({
      voteName: this.option.voteName,
      page: this.page,
      type: this.listActiveType,
      search: this.SearchData,
    }).then((res: any) => this.endVoteListData(res));
  }
}
